<template>
    <div class="mb-3">
        <div v-if="data!==undefined">
            <div v-for='(i,index) in data' :key="index" v-show="status===false || status===undefined" class="panelList w-100 box-shadow mt-3 py-2 f-12 border-radius-4 bg-white">
                <div class="col-12">
                    <label class="m-0 note p-0 pt-2 w-100 commit" v-if="i.text!==undefined" v-html="i.text"></label>
                    <label class="m-0 note p-0 w-100 commit" v-if="i.v!==undefined" v-html="i.v"></label>
                    <hr>
                </div>
                <div class="row w-100 pl-3">
                <div class="col-9 d-flex flex-column justify-content-senter align-items-start pb-2">
                    <label class="m-0 mb-1" v-if="i.created_at!==undefined">{{ formatDate(i.created_at.$date, "Do MMMM YYYY")}}</label>
                    <label class="m-0" v-if="i.date!==undefined">{{ formatDate(i.date.$date, "Do MMMM YYYY")}}</label>
                    <button class="btn-new bg-new-gray p-1" v-if="i.cuid!=undefined && users.find(usr => usr._id['$oid']==i.cuid.$oid)!=null">
                        {{users.find(usr => usr._id['$oid']==i.cuid.$oid).name}}
                        {{users.find(usr => usr._id['$oid']==i.cuid.$oid).surName}}
                    </button>
                </div>
                
                <div class="col-3 d-flex pr-0 justify-content-end align-items-center" v-if="field==='organization'">
                    <div v-if="!i._id" class="d-flex align-items-center">  
                        <button @click="deleteSelectedNotes(index,i.id.$oid)" class="btn crm-detail-icon-btn p-1 d-flex justify-content-center align-items-center">
                            <span class="fas fa-trash-alt crm-icon-color"></span>
                        </button>
                        <button class="btn crm-detail-icon-btn p-1 ml-1 d-flex justify-content-center align-items-center" @click="selected=i.id.$oid">
                            <span class="fa fa-edit crm-icon-color"></span>
                        </button>
                    </div>
                    <div v-else class="d-flex align-items-center ml-2">
                         <button @click="deleteSelectedNotes(index,i._id.$oid)" class="btn crm-detail-icon-btn p-1 d-flex justify-content-center align-items-center">
                            <span class="fas fa-trash-alt crm-icon-color"></span>
                        </button>
                        <button class="btn crm-detail-icon-btn p-1 ml-1 d-flex justify-content-center align-items-center" @click="selected=i._id.$oid">
                            <span class="fa fa-edit crm-icon-color"></span>
                        </button>
                    </div>
                    <!-- <div v-if="$can('can_delete_notes')" class="ml-2">
                        <button @click="deleteSelectedNotes(index,i.id.$oid)" class="btn p-1">
                            <span class="fa fa-trash"></span>
                        </button>
                    </div> -->
                </div>
                    <!--  v-if="$can('can_update_notes') && $can('can_delete_notes')" -->
                <div v-if="field==='dealCard'" class="col-3 pr-0 d-flex justify-content-end align-items-center">
                    <div class="d-flex justify-content-center align-items-center">  
                        <button @click="deleteSelectedNotes(index,i.id.$oid)" class="btn p-1 mr-1 crm-detail-icon-btn d-flex justify-content-center align-items-center">
                            <span class="fas fa-trash-alt crm-icon-color"></span>
                        </button>
                        <button class="btn p-1 crm-detail-icon-btn d-flex justify-content-center align-items-center" @click="selected=i.id.$oid">
                            <span class="fas fa-pencil-alt crm-icon-color"></span>
                        </button>
                    </div>
                    <!-- <div v-if="$can('can_update_notes')" class="" @click="selected=i.id.$oid">
                        <button class="btn p-0" @click="selected=i.id.$oid">
                        <span class="fa fa-edit"></span>
                        </button>
                    </div>
                    <div v-if="$can('can_delete_notes')" class="">
                        <button @click="deleteSelectedNotes(index,i.id.$oid)" class="btn p-0 mr-1">
                            <span class="fa fa-trash"></span>
                        </button>
                    </div> -->
                </div>

                <div v-if="field==='contact'" class="col-3 pr-0 d-flex justify-content-end align-items-center">
                    <div class="d-flex justify-content-center align-items-center">  
                        <button @click="deleteSelectedNotes(index,i.id.$oid)" class="btn p-1 mr-1 crm-detail-icon-btn d-flex justify-content-center align-items-center">
                            <span class="fas fa-trash-alt crm-icon-color"></span>
                        </button>
                        <button class="btn p-1 crm-detail-icon-btn d-flex justify-content-center align-items-center" @click="selected=i.id.$oid">
                            <span class="fas fa-pencil-alt crm-icon-color"></span>
                        </button>
                    </div>
                </div>
              
                <div v-if="field==='organization'&&!i._id" v-show="selected===i.id.$oid" class=" row w103 pt-2 pl-3">
                    <div class="col-11 pr-0">
                        <textarea type="text" class="border pl-2 pt-2  light-blue-border w103 f-14 font-family-regular border-radius-4" rows="3" :value="updateNote[index]=convertHtml(i.text)" @input="definedNot(index,$event.target.value)" />
                    </div>
                    <div class="col-1 pl-1 d-flex flex-column justify-content-center align-items-end pr-0">
                        <i class="fa fa-check-square clickable fs22" @click="noteUpdate(index,updateNote[index],i.id.$oid)" ></i>
                        <i class="fa fa-times-square clickable fs20 mt-1" @click="selected=''"></i>
                   </div>
                </div>
                <div v-if="field==='organization'&&i._id" v-show="selected===i._id.$oid" class=" row w103 pt-2 pl-3">
                    <div class="col-11 pr-0">
                        <!-- text area entera tıklanınca kaydetmesin istendiği için kaldırıldı. @keyup.enter="noteUpdate(index,updateNote[index],i._id.$oid)" -->
                        <textarea type="text" class="border pl-2 pt-2  light-blue-border w103 f-14 font-family-regular border-radius-4" rows="3" :value="updateNote[index]=convertHtml(i.text)" @input="definedNot(index,$event.target.value)" />
                    </div>
                    <div class="col-1 pl-1 d-flex flex-column justify-content-center align-items-end pr-0">
                        <i class="fa fa-check-square clickable fs22" @click="noteUpdate(index,updateNote[index],i._id.$oid)" ></i>
                        <i class="fa fa-times-square clickable fs20 mt-1" @click="selected=''"></i>
                   </div>
                </div>

                <div v-if="field==='dealCard'" v-show="selected===i.id.$oid" class=" row w103 pt-2 pl-3">
                    <div class="col-11 pr-0">
                        <textarea type="text" class="border pl-2 pt-2 border-radius-4 light-blue-border w103 f-14 font-family-regular" rows="3" @keyup.enter="noteUpdateDeal(index,updateNote[index],i.id.$oid)" :value="updateNote[index]=convertHtml(i.text)" @input="definedNot(index,$event.target.value)" />
                    </div>
                    <div class="col-1 pl-1 d-flex flex-column justify-content-center align-items-end pr-0">
                        <i class="fa fa-check-square clickable fs22" @click="noteUpdateDeal(index,updateNote[index],i.id.$oid)" ></i>
                        <i class="fa fa-times-square clickable mt-1 fs20 " @click="selected=''"></i>
                    </div>   
                </div>

                <div v-if="field==='contact'" v-show="selected===i.id.$oid" class="row w103 pl-3 pt-2">
                    <div class="col-11 pr-0">
                        <textarea type="text" class="border pl-2 pt-2 border-radius-4 light-blue-border w103 f-14 font-family-regular" rows="3" @keyup.enter="noteUpdateContact(index,updateNote[index],i.id.$oid)" :value="updateNote[index]=convertHtml(i.text)" @input="definedNot(index,$event.target.value)" />
                    </div>
                    <div class="col-1 pl-1 pr-0 d-flex flex-column justify-content-center align-items-end"> 
                        <i class="fa fa-check-square clickable fs22" @click="noteUpdateContact(index,updateNote[index],i.id.$oid)" ></i>
                        <i class="fa fa-times-square clickable mt-1 fs20" @click="selected=''"></i>
                    </div>    
                </div>
                </div>
            
            </div>
            <div v-if="status">
                <div v-for='s in data'>
                    <div v-for='i in s'>
                        <label class="m-0 f-14 note p-0 w-100 commit" v-if="i.text!==undefined" v-html="i.text"></label>
                        <label class="m-0 f-14 note p-0 w-100 commit" v-if="i.v!==undefined" v-html="i.v"></label>
                        <label class="m-0 f-14" v-if="i.created_at!==undefined">{{ formatDate(i.created_at.$date, "Do MMMM YYYY")}}</label>
                        <template v-for="u in users" :key="u && u._id ? u._id.$oid : u.name">
                            <label class="f-14 m-0" v-if='i.cuid && i.cuid.$oid && u && u._id && u._id.$oid===i.cuid.$oid'>{{u.name}} {{u.surName}}</label>
                        </template>
                        <template v-for="u in users" :key="u && u._id ? u._id.$oid : u.name">
                            <label class="f-14 m-0" v-if='i.uid && i.uid.$oid && u && u._id && u._id.$oid===i.uid.$oid'>{{u.name}} {{u.surName}}</label>
                        </template>
                        <br>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <label class="m-0 f-14 note p-0 w-100 commit">{{$ml.get('NO_COMMENT_YET')}}!</label>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { VueEditor, Quill } from 'vue2-editor'
import Swal from 'sweetalert2'
import {mapState} from 'vuex'
export default {
  name: 'showNotePanel',
    data () {
        return {
            selected:"",
            updateNote:[],
        }
    },
    props:["data","users","field","status","organization","deal","contact"],
    computed:{
        ...mapState([
            'baseUrl',
        ]),
    },
    methods:{
      formatDate(value, format) {
        return this.$moment(value).format(format);
      },
      deleteSelectedNotes(index,notId){
      console.log("delete tıklandı");
      console.log(this.field);
      var confirm_message = this.$ml.get('DELETE_NOTE_CONFIRM')
      Swal.fire({
          title: this.$ml.get('DELETE_NOTE'),
          text: confirm_message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: this.$ml.get('DELETE_NOTE_CONFIRM_BTN_TXT'),
          cancelButtonText: this.$ml.get('CANCEL'),
          customClass:{
              icon:'custom-delete-warning',
              cancelButton:'custom-delete-cancel-button'
          },
          reverseButtons:true
      }).then((result)=>{
          if(result.isConfirmed){
            if(this.field==='organization'){
                this.deleteOrganizationNote(index,notId)
            }
            else if(this.field==='dealCard'){
                this.deleteDealNote(index,notId)
            }
            else if(this.field==='contact'){
                this.deleteContactNote(index,notId)
            }
              
        }
      })
    },
     deleteOrganizationNote(index,notId){
            axios({
                method:'POST',
                url:'/upsertOrganizationNote',
                baseURL: this.baseUrl,
                data: {
                    organizationId:this.organization._id.$oid,
                    noteText:'',
                    organizationNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS_NOTE_HAS_BEEN_DELETED'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    // this.notes.splice(index,1);
                    // this.data.splice(this.data.indexOf(i),1);
                    this.data.splice(index,1)
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        deleteDealNote(index,notId){
            axios({
                method:'POST',
                url:'/upsertDealNote',
                baseURL: this.baseUrl,
                data: {
                    dealId:this.deal._id.$oid,
                    noteText:'',
                    dealNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS_NOTE_HAS_BEEN_DELETED'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    // this.notes.splice(index,1);
                    // this.data.splice(this.data.indexOf(i),1);
                    this.data.splice(index,1)
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        deleteContactNote(index,notId){
            axios({
                method:'POST',
                url:'/deleteNote',
                baseURL: this.baseUrl,
                data: {
                    contactId:this.contact._id.$oid,
                    deleteNote:'',
                    noteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESS_NOTE_HAS_BEEN_DELETED'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    // this.notes.splice(index,1);
                    this.data.splice(index,1)
                    // this.data.splice(this.data.indexOf(i),1);
                     
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        noteUpdateDeal(index,i,notId){
             console.log(index);
            i = '<p>'+i+'</p>'
            axios({
                method:'POST',
                url:'/upsertDealNote',
                baseURL: this.baseUrl,
                data: {
                    dealId:this.deal._id.$oid,
                    noteText:i,
                    dealNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    this.data[index]=res.data.content.i
                    this.$emit("refleshData")
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        noteUpdateContact(index,i,notId){
             console.log(this.data);
             console.log(index);
            i = '<p>'+i+'</p>'
            axios({
                method:'POST',
                url:'/updateNote',
                baseURL: this.baseUrl,
                data: {
                    contactId:this.contact._id.$oid,
                    note:i,
                    noteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    // this.data[index]=res.data.content.i
                    this.$emit("getContact")
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        noteUpdate(index,i,notId){
             console.log(index);
            i = '<p>'+i+'</p>'
            axios({
                method:'POST',
                url:'/upsertOrganizationNote',
                baseURL: this.baseUrl,
                data: {
                    organizationId:this.organization._id.$oid,
                    noteText:i,
                    organizationNoteId:notId
                },
                withCredentials:true
            }).then((res)=>{
                return res
            }).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc
                    })
                    this.selected=""
                    this.data[index]=res.data.content.i
                    this.$emit("refleshData")
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: res.data.status.desc
                    })
                     
                }
            })
        },
        convertHtml(value){
            if(this.isHTML(value)){
                return $(value).html()
            }else{
                return value
            }
        },
        definedNot(index,value){
            this.updateNote[index]=value
        },
        isHTML(str) {
            var doc = new DOMParser().parseFromString(str, "text/html");
            return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
        },
    },
    created(){
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.note p{
    padding: 0!important;
    margin: 0!important;
}
.commit :deep(p){
    margin: 0px!important;
}
.fs20{
    font-size: 20px !important;
}
.fs22{
    font-size: 22px !important;
}
.w103{
    width: 103%;
}
.btnNote{
    background: transparent;
}
</style>
